import { render, staticRenderFns } from "./JumpDialog.vue?vue&type=template&id=195d9036&scoped=true"
import script from "./JumpDialog.vue?vue&type=script&lang=js"
export * from "./JumpDialog.vue?vue&type=script&lang=js"
import style0 from "./JumpDialog.vue?vue&type=style&index=0&id=195d9036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195d9036",
  null
  
)

export default component.exports